
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './App.css';


import Inicio from './componentes/Inicio';
import Cabecera from './componentes/Cabecera';
import Footer from './componentes/PieDePagina';
import ConcejoMunicipal from './componentes/ConcejoMunicipal';
import Organigrama from './componentes/Organigrama';
import Coprosec from './componentes/Coprosec';
import Instrumentos from './componentes/Instrumentos';
import Enlaces from './componentes/Enlaces';
import Expedientes from './componentes/Expedientes';
import Convocatorias from './componentes/Convocatorias';
import Galeria from './componentes/Galeria';
import ScrollTop from './componentes/ScrollTop';
import Nombramientos from './componentes/Nombramientos';
import Comisiones from './componentes/Comisiones';
import Concursos from './componentes/Concursos';
import Turismo from './componentes/Turismo';
import Rendiciones from './componentes/Rendiciones';
import Certificados from './componentes/Certificados';
import Test from './componentes/Test';
import Test2 from './componentes/Test2';



function App() {
  return (
    <div className="App">
      <Router>
        <ScrollTop/>
        <Enlaces/>
        <Cabecera/>
        <div className='Content'>
          <Routes>
            <Route path='/' element={<Inicio/>}/>
            <Route path='/Concejo' element={<ConcejoMunicipal/>}/>
            <Route path='/Comisiones' element={<Comisiones/>}/>
            <Route path='/Organigrama' element={<Organigrama/>}/>
            <Route path='/Coprosec' element={<Coprosec/>}/>
            <Route path='/Instrumentos' element={<Instrumentos/>}/>
            <Route path='/Expedientes' element={<Expedientes/>}/>
            <Route path='/Convocatorias' element={<Convocatorias/>}/>
            <Route path='/Nombramientos' element={<Nombramientos/>}/>
            <Route path='/Galeria' element={<Galeria/>}/>
            <Route path='/Concursos' element={<Concursos/>}/>
            <Route path='/Certificados' element={<Certificados/>}/>
            <Route path='/Test' element={<Test/>}/>
            <Route path='/Test2' element={<Test2/>}/>
            <Route path='/Atractivos-Turisticos' element={<Turismo/>}/>
            <Route path='/Rendiciones' element={<Rendiciones/>}/>
          </Routes>
        </div>
        <Footer/>
      </Router>
    </div>
  );
}
export default App;
